export const IS_FULL_ERROR_CODE = '1x0040008';
